import { useAsyncRetry } from 'react-use';
import { useActiveProject } from './useActiveProject';
import { CarePlanService } from '../services/CarePlanService';
import { CODE_ACTION_PLAN, SYSTEM_ACTION_PLAN } from '../util/fhir';
import { useActiveProjectCohortId } from './useActiveProjectCohortId';
import useService from './useService';
import { compareActionPlansForLatestView } from '../util/actionPlans';

const actionPlanService = new CarePlanService();

export const useCarePlans = (patientId: string) => {
  const [project] = useActiveProject();
  const [listActionPlan] = useService(actionPlanService.listCarePlans);
  const cohort = useActiveProjectCohortId();

  const state = useAsyncRetry(async (): Promise<fhir.CarePlan[]> => {
    const plans =
      (await listActionPlan(patientId, cohort, project.id)).data.entry
        ?.map(entry => entry.resource as fhir.CarePlan)
        ?.filter(resource =>
          resource?.category?.some(c =>
            c.coding?.some(
              coding =>
                coding.system === SYSTEM_ACTION_PLAN &&
                coding.code === CODE_ACTION_PLAN,
            ),
          ),
        ) ?? [];
    return plans.sort(compareActionPlansForLatestView);
  }, [listActionPlan, project.id, patientId, cohort]);

  return {
    carePlans: state.value,
    refetchCarePlans: state.retry,
    loading: state.loading,
  };
};
